export default __webpack_public_path__ + "static/media/promo-given.ca0cfabe.webp";